module.exports = __webpack_public_path__ + "static/media/banner4.c257cde7.png";